import SocialCoverShareComponent from './components/share';
import store from '~/base_store';
import SocialCoversModule from './store';
import OembedModule from '~/bundles/oembed/store';

$(() => {
    const $el = $('#vue-share-social-media');
    window.gl = window.gl || {};

    if (gl.SocialCoverShareApp) {
        gl.SocialCoverShareApp.$destroy(true);
    }

    if ($el.length) {
        store.registerModule('socialShare', SocialCoversModule);
        store.registerModule('oembed', OembedModule);

        gl.SocialCoverShareApp = new SocialCoverShareComponent({
            el: $el.get(0),
            store,
            propsData: {
                showMediaLibrary: false,
            },
        });

        $('#content').on('click', '.vue-social-post-btn', function () {
            const vm = gl.SocialCoverShareApp;
            const mediaId = $(this).data('media-id') || null;
            const isEditable = $(this).data('editable');
            const savedMediaId = $(this).data('saved-media-id') || null;
            const mediaCategory = $(this).data('media-category') || null;

            vm.mediaId = mediaId;
            vm.$store.commit('socialShare/updateFormData', {
                saved_media_id: savedMediaId,
            });
            vm.$store.commit('socialShare/updateFormEditableParam', isEditable);
            vm.$store.commit('socialShare/updateFormMediaCategoryParam', mediaCategory);
            vm.getFormData(vm.mediaId);
            vm.open();
        });
    }
});
